import { forwardRef, useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import Modal from "./Modal";

const ModalApp = forwardRef(function ModalApp(props, ref) {
  let root;
  const [openModal, setOpenModal] = useState(props.open || false);
  useEffect(() => setOpenModal(props.open), [props.open]);

  function handleUnMountOverlay(cb) {
    root && root.unmount();

    cb && cb();
    props?.onClose?.(false);
  }

  ref.onHandle = handleUnMountOverlay;

  useEffect(() => {
    if (!openModal) {
      return;
    }

    root = createRoot(window?.pdfDoc?.getElementById("overlay"));
    ref.root = root;
    window.pdfWin.getSelection().removeAllRanges();

    props?.onMount?.(root);
    root.render(
      <div className="latex-modal-backdrop">
        <Modal
          open={true}
          title={props.title}
          clickAway={false}
          onClose={() => handleUnMountOverlay()}
          style={{ width: 260, height: 110, ...props.style }}
          body={props.body}
          pos={props.pos}
          footer={props.footer}
        />
      </div>
    );

    return () => props?.onUnmount?.();
  }, [openModal]);

  return <></>;
});

export default ModalApp;
